jQuery(function ($) {
  // Navbar Submenu Dropdown Links Click - Mobile
  $(".menu-toggle").on("click", function (e) {
    $(this).toggleClass("collapsed");

    var $subMenu = $(this).parent().next(".sub-menu");
    $subMenu.toggleClass("slideInUp animated show");

    return false;
  });

  // Navbar Toggler
  $(".nav-toggler").on("click", function (e) {
    $(".nav-search-icon").removeClass("nav-search-icon--close");
    $("#search-box").css("display", "none");
    $(this).toggleClass("is-active");
    $("div.nav-collapse").toggleClass("show");
  });

  // Menu Search Trigger
  $(".nav-search-icon").click(function (e) {
    e.stopPropagation();
    e.preventDefault();
    $(".nav-toggler").removeClass("is-active");
    $(".nav-collapse").removeClass("show");
    $(this).toggleClass("nav-search-icon--close");
    $("#search-box").fadeToggle(350);
    $("#search-box .search-field").focus();
  });

  // Hide Menu Search Trigger on Document Click
  $(document).on("click", function (event) {
    var eventClick = $(event.target).closest("#search-box").length;
    if (!eventClick) {
      $("#search-trigger").removeClass("nav-search-icon--close");
      $("#search-box").fadeOut(350);
    }
  });

  // Add smooth scroll to anchor links. Just add the "smooth" class to your links
  $(
    'a.smooth[href*="#"]:not([href="#"]), li.smooth a[href*="#"]:not([href="#"])'
  ).on("click", function () {
    if (
      location.pathname.replace(/^\//, "") ==
        this.pathname.replace(/^\//, "") &&
      location.hostname == this.hostname
    ) {
      var target = $(this.hash);
      target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
      if (target.length) {
        $("html,body").animate(
          {
            scrollTop: target.offset().top,
          },
          500
        );
        return false;
      }
    }
  });

  // Accordion
  $(".acc-trigger").on("click load", function (e) {
    e.preventDefault();
    if ($(this).hasClass("acc-active")) {
      $(this).removeClass("acc-active");
      $(this).siblings(".acc-content").slideUp(200);
      // $(".set > a i").removeClass("fa-minus").addClass("fa-plus");
    } else {
      // $(".set > a i").removeClass("fa-minus").addClass("fa-plus");
      // $(this).find("i").removeClass("fa-plus").addClass("fa-minus");
      $(".acc-trigger").removeClass("acc-active");
      $(this).addClass("acc-active");
      $(".acc-content").slideUp(200);
      $(this).siblings(".acc-content").slideDown(200);
    }
  });

  // Contact Form 7 Placeholder Hide on Focus
  $("input,textarea")
    .focus(function () {
      $(this)
        .data("placeholder", $(this).attr("placeholder"))
        .attr("placeholder", "");
    })
    .blur(function () {
      $(this).attr("placeholder", $(this).data("placeholder"));
    });

  // Comments - Add Padding to Comment Respond
  $(".comment-reply-link").click(function () {
    $(".comment-respond").addClass("is-open");
  });

  $("#cancel-comment-reply-link").click(function () {
    $(".comment-respond").removeClass("is-open");
  });

  // Checkout Coupon Modal
  $(".show-modal").on("click", function () {
    $(".modal-overlay").addClass("modal-active");
  });

  function closeModal() {
    $(".modal-overlay").removeClass("modal-active");
  }

  // Call the closeModal function on the clicks/keyboard
  $(".modal-close, .modal-overlay").on("click", function () {
    closeModal();
  });

  $(document).keyup(function (e) {
    if (e.keyCode == 27) {
      closeModal();
    }
  });

  // Back To Top Button
  $(window).scroll(function () {
    if ($(this).scrollTop() > 200) {
      $(".backtotop").fadeIn();
    } else {
      $(".backtotop").fadeOut();
    }
  });

  $(".backtotop").click(function () {
    $("html, body").animate({ scrollTop: 0 }, 600);
    return false;
  });

  // Horizontal Scrolling - Grabbing
  const slider = document.querySelector(".as-seen-on__box");
  let isDown = false;
  let startX;
  let scrollLeft;

  if (slider) {
    slider.addEventListener("mousedown", (e) => {
      isDown = true;
      slider.classList.add("active");
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });
    slider.addEventListener("mouseleave", () => {
      isDown = false;
      slider.classList.remove("active");
    });
    slider.addEventListener("mouseup", () => {
      isDown = false;
      slider.classList.remove("active");
    });
    slider.addEventListener("mousemove", (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 3; //scroll-fast
      slider.scrollLeft = scrollLeft - walk;
    });
  }
});

// On resize
$(window).on("load resize", () => {
  const $redStepsTwo = $("#red-steps-2");
  const $redStepsThree = $("#red-steps-3");

  if ($(window).width() < 993) {
    $($redStepsTwo).insertBefore($redStepsThree);
  } else {
    $(".red-steps__two").append($redStepsTwo);
  }
});
